'use strict'
export let english_productPlan={
  approval: {
    fields: {
      approvedBy: {
        title: "Updated by"
      }
    }
  }
};



// WEBPACK FOOTER //
// ./views/brief/labels/product/english#productPlan.js